export default __webpack_public_path__ + "static/frontpage-banner-bg-fallback-76d54e55a6436803c1fdad4d01e292ba.png";